import { css } from 'styled-components';

export default css`
  ${(props) =>
    props.spc ? `margin-bottom: ${props.theme.spacing.ELEM_SPACING.LRG}; padding-top: 20px;` : ''}
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      props.newTile && props.isDesktopProductTileCleanUpDisabled ? `padding-top: 20px;` : ''}
  }

  ${(props) => (!props.blockView ? `display: flex;` : '')}
  ${(props) =>
    !(props.spc || props.spcBag) ? `margin-top: ${props.theme.spacing.ELEM_SPACING.REG};` : ''}

  ${(props) =>
    props.isNewQVEnabled && props.paddingBottom
      ? `margin-bottom: ${props.theme.spacing.ELEM_SPACING.REG};`
      : ''}
  .label-wrapper {
    ${(props) =>
      !(props.spc || props.spcBag)
        ? `display: flex;
          align-items: center;
          flex-wrap: wrap;`
        : ''};
  }

  .sth-icon {
    width: 26px;
    height: 22px;
    vertical-align: bottom;
    margin-right: 4px;
  }

  .label-ship-by {
    padding-right: 5px;
    ${(props) => (!(props.spc || props.spcBag) ? `white-space: nowrap;` : '')};
  }

  .estimated-shipping-date {
    white-space: nowrap;
    display: inline-block;
  }

  .pod-estimated-shipping-date {
    color: ${(props) => props.theme.brandSpecificStyles.EXTENDED_PREORDER_COLOR};
    font-family: Nunito;
    font-weight: 800;
    text-transform: uppercase;
    font-size: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    text-align: ${(props) => (props.isQVOpen ? 'center' : 'left')};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
      padding: 0px 14px;
    }
  }
`;
